/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertLicenseIcon20Solid = forwardRef('CertLicenseIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3v2.598a.5.5 0 0 1-.765.424l-1.102-.69a.25.25 0 0 0-.265 0l-1.103.69a.5.5 0 0 1-.765-.424V16H5a3 3 0 0 1-3-3V5Zm11 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM4.85 5.75A.75.75 0 0 1 5.6 5h8.8a.75.75 0 0 1 0 1.5H5.6a.75.75 0 0 1-.75-.75ZM7.5 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z" })));
});
